import { useEffect, useRef, useState } from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const solutions = [
{
  tag: "Saltak",
  title: "LYKKE LY",
  desc: "Naturlig tilpasset landskapet. Saltaket gir en klassisk form og er utviklet for å håndtere vær og belastning. En robust badstue tilpasset krevende forhold.",
  image: "https://media.base44.com/images/public/69ddf0e05a57ca57b48414c4/dbd19d94b_Zrzutekranu2026-05-10o123230.png",
  href: "/sauna-ly"
},
{
  tag: "Flatt tak",
  title: "LYKKE PANORAMA",
  desc: "Enkel form, åpen mot omgivelsene. Flatt tak gir et rent og moderne uttrykk og åpner for store glassflater. En badstue med tett kontakt til naturen.",
  image: "https://media.base44.com/images/public/69ddf0e05a57ca57b48414c4/038e9ce64_Vikka2.png",
  href: "/sauna-panorama"
},
{
  tag: "Skråtak",
  title: "LYKKE FJELL",
  desc: "Utviklet for funksjon og forhold. En badstue med skråtak som gir god avrenning og naturlig overgang mellom arkitektur og omgivelser.",
  image: "https://media.base44.com/images/public/69ddf0e05a57ca57b48414c4/dab983686_SAUNAVEIBER_8.jpg",
  href: "/sauna-fjel"
}];


export default function SolutionsSection() {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {if (entry.isIntersecting) setVisible(true);},
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="losninger" ref={ref} className="py-24 md:py-40">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12">
        <div className="text-center mb-20">
          <p className="tracking-widest-2xl font-body uppercase text-primary mb-6" style={{ fontSize: "23px" }}>
            15 forskjellige badstuer
          </p>
          <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl font-light">
            Tre ulike arkitektoniske retninger.
            <br />
            <span className="italic">Samme kvalitet.</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {solutions.map((s, i) =>
          <Link
            to={s.href}
            key={i}
            className={`group cursor-pointer transition-all duration-700 ${
            visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`
            }
            style={{ transitionDelay: `${i * 200}ms` }}>
            
              <div className="aspect-[3/4] overflow-hidden mb-6">
                <img
                src={s.image}
                alt={s.title}
                className="w-full h-full object-contain object-center group-hover:scale-105 transition-transform duration-[1.5s]" />
              
              </div>
              <p className="text-sm tracking-widest-2xl font-body uppercase text-primary/70 mb-2">
                {s.tag}
              </p>
              <h3 className="font-heading text-xl md:text-2xl tracking-widest-xl mb-3">
                {s.title}
              </h3>
              <p className="text-foreground/60 mb-4 text-2xl font-body leading-relaxed">
                {s.desc}
              </p>
              <span className="inline-flex items-center gap-2 text-sm tracking-widest-xl font-body uppercase text-foreground/80 group-hover:text-foreground transition-colors">
                Utforsk <ArrowRight size={12} strokeWidth={1.5} className="group-hover:translate-x-1 transition-transform" />
              </span>
            </Link>
          )}
        </div>
      </div>
    </section>);

}